const assign_key = (json) => {
  const new_key = Object.keys(json).length !== 0 ? Math.max(...Object.keys(json)) + 1 : 0
  return new_key
}

export default assign_key
